import React from 'react';
import {
  ATMDivider,
  ATMForm,
  ATMGrid,
  ATMHeader,
  ATMSegment,
} from 'shared-it-appmod-ui';
import FieldReadOnlyCommment from 'src/components/atoms/field/field-readonly-comment/field-readonly-comment.component';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import FlagReadOnly from 'src/components/atoms/flag-readonly/flag-readonly.component';
import FileManager from 'src/components/molecules/file-manager/file-manager.component';
import Lang from 'src/libraries/language';
// import { IRequest } from 'src/models/request.model';
import FlightRequestCircuit from '../flight-request-circuit/flight-request-circuit.component';
import FlightRequestContactInformation from '../flight-request-contact-information/flight-request-contact-information.component';
import FlightRequestPassengerInformation from '../flight-request-passenger-information/flight-request-passenger-information.component';
import styles from './flight-request-patrol-passenger-contractor.module.scss';

// type IProps = {
//   data: IRequest;
// };

const FlightRequestPatrolPassengerContractor: React.FC<any> = ({
  data: { request, passengerFlight },
}) => {
  return (
    <ATMSegment color="purple" className={styles.wrapper}>
      <ATMHeader>{Lang.TTL_REQUEST_PATROL_PASSENGER_CONTRACTOR}</ATMHeader>

      <ATMForm>
        <ATMGrid columns={2}>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_FLIGHT_TYPE}>
              {passengerFlight.flightType}
            </FieldReadOnly>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_DISTRICT_NAME}>
              {passengerFlight.district}
            </FieldReadOnly>
          </ATMGrid.Column>
        </ATMGrid>

        <ATMGrid columns={2}>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_PROJECT}>
              {request.requestorDistrict ?? passengerFlight.project}
            </FieldReadOnly>
          </ATMGrid.Column>
        </ATMGrid>

        <FlightRequestCircuit data={passengerFlight.circuitInfos} />

        <ATMGrid columns={3}>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_PICKUP_LOCATION}>
              {passengerFlight.pickupLocation}
            </FieldReadOnly>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_FLIGHT_DESTINATION}>
              {passengerFlight.destination}
            </FieldReadOnly>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FieldReadOnly label={Lang.LBL_COORINATES}>
              {passengerFlight.coordinates}
            </FieldReadOnly>
          </ATMGrid.Column>
        </ATMGrid>

        <FlightRequestPassengerInformation
          data={passengerFlight.passengerInfos}
        />

        <ATMHeader size="small" className="text-underline">
          {Lang.LBL_OTHER_INFORMATION}
        </ATMHeader>

        <ATMGrid columns={1}>
          <ATMGrid.Column>
            <FlagReadOnly
              value={passengerFlight.nightFlag}
              label={Lang.LBL_NIGHT_FLIGHT}
            />
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FlagReadOnly
              label={Lang.LBL_AOM_REVIEW}
              value={passengerFlight.aomFlag}
            />
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FlagReadOnly
              label={Lang.LBL_TRACKING_DEVICE}
              value={passengerFlight.asdTrackingFlag}
            />
          </ATMGrid.Column>
          <ATMGrid.Column>
            <FlagReadOnly
              label={Lang.LBL_TWO_WAY_RADIO}
              value={passengerFlight.asdRadioFlag}
            />
          </ATMGrid.Column>
        </ATMGrid>

        <FlightRequestContactInformation data={passengerFlight} />

        <ATMHeader size="small" className="text-underline">
          {Lang.LBL_FLIGHT_AREA}
        </ATMHeader>
        <ATMForm.Field>
          <FileManager
            files={passengerFlight.flightAreaFiles}
            editable={false}
            inline
          />
        </ATMForm.Field>
        <ATMDivider />

        <ATMHeader size="small" className="text-underline">
          {Lang.LBL_ADDITIONAL_COMMENT}
        </ATMHeader>

        {/* <ATMGrid columns={2}>
          <ATMGrid.Column> */}
        <FieldReadOnlyCommment>
          {passengerFlight.comments}
        </FieldReadOnlyCommment>
        {/* </ATMGrid.Column>
        </ATMGrid> */}
      </ATMForm>
    </ATMSegment>
  );
};

export default FlightRequestPatrolPassengerContractor;
